import { Text } from "@ui-component-library";
import { TailwindWrapper } from "@utils/TailwindWrapper";

export const TextPosts = (props: { text?: string }) => {
  
    return (
        <TailwindWrapper>   
            <div className="mx-auto mb-6 flex max-w-[720px] flex-col px-4 sm:px-6">
                <Text variant="text-base/leading-normal/normal">
                {props.text || "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque vitae velit ex. Mauris dapibus risus quis suscipit vulputate."}
                </Text>
            </div>
        </TailwindWrapper> 
    );
  };

  TextPosts.fields = {
    text: {
        type: "textarea",
        label: "Body text",
      },
}